import { render, staticRenderFns } from "./Musteri.vue?vue&type=template&id=1146bc36&scoped=true&"
import script from "./Musteri.vue?vue&type=script&lang=js&"
export * from "./Musteri.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1146bc36",
  null
  
)

export default component.exports